import React from 'react'
import {
  NarrativeBlock as NarrativeBlockData,
  NarrativeSectionKey,
} from '@marketing-milk/interfaces'
import { SurfacePalette } from '../../tokens'
import { NarrativeBlock } from '../../components/NarrativeBlock'
import { SectionCard } from './SectionCard'

interface Props {
  palette: SurfacePalette
  sectionKey: NarrativeSectionKey
  label: string
  packetID: number
  narrative: NarrativeBlockData[]
}

export const NarrativeSection = ({ palette, sectionKey, label, packetID, narrative }: Props) => {
  const block = narrative.find(b => b.sectionKey === sectionKey)
  const text = block?.richText?.trim() ?? ''

  return (
    <SectionCard
      palette={palette}
      sectionKey={sectionKey}
      title={label}
      commentAnchor={{ type: 'section', id: `${packetID}:${sectionKey}`, label }}
    >
      <NarrativeBlock palette={palette} empty={!text}>
        {text || 'Empty. v0.11 swaps this stub for a rich-text editor with auto-save.'}
      </NarrativeBlock>
    </SectionCard>
  )
}
